import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MyMatchesPageRoutingModule } from './my-matches-routing.module';

import { MyMatchesPage } from './my-matches.page';
import { TranslateModule } from '@ngx-translate/core';
import { AdsModule } from '../_shared/components/ads/ads.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MyMatchesPageRoutingModule,
        TranslateModule.forChild(),
        AdsModule
    ],
    declarations: [
        MyMatchesPage
    ]
})
export class MyMatchesPageModule { }
